module.exports = __webpack_public_path__ + "static/roboto-mono-v7-latin-500italic-b340d3a4eb064d6cbe74a55f51e3ea50.woff2";